import React from 'react';
import AdminMainTabPanel from './adminPanels/AdminMainTabPanel'

export default function AdminTab(props) {
  console.log("render AdminTab");

  return (
    <div name="divAdminTab">
      <AdminMainTabPanel/>
      {/*tabPanelIndex === MainTabPanelIndex ? <AdminMainTabPanel/> : <></>*/} 
    </div>
  );
}

